import React, { Component } from 'react';
import Style from './HeroSection.css';
import Button from '../Button/Button';

class HeroSection extends Component {
	render() {
		return (
			<div style={Style.HeroSection} className="hero-section">
				<div className="plx-container">
					<div className="mobile-hero"></div>
					<div className="container">
						<div className="hero-heading">
							<h1>ARIZONA ACADEMICS</h1>
							<p>Whether you know exactly what you want to study or are looking for a supportive learning environment to figure it out, the University of Arizona will help you graduate ready to tackle your goals.</p>
							<Button buttonLink="https://www.arizona.edu/degree-search/" buttonId="explore-majors-hero" buttonTitle="EXPLORE MAJORS" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default HeroSection;
